import { render, staticRenderFns } from "./AdminPushNotifications.vue?vue&type=template&id=1d25b2a7&scoped=true&lang=pug&"
import script from "./AdminPushNotifications.vue?vue&type=script&lang=js&"
export * from "./AdminPushNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AdminPushNotifications.vue?vue&type=style&index=0&id=1d25b2a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25b2a7",
  null
  
)

export default component.exports